import React from "react";
import { Col } from "../Grid";

export const TestimonialColInfo = ({ ...props }) => (
	<Col
		lg={6}
		spacing={{
			sm: {
				pl: 8,
				pr: 12,
				py: 6,
			},
			md: {
				pl: 12,
				pr: 12,
				py: 10,
			},
		}}
		{...props}
	/>
);

export const TestimonialColVideo = ({ ...props }) => (
	<Col lg={6} className="hide-for-medium-only" {...props} />
);

export const TestimonialColImage = ({ ...props }) => <Col lg={6} {...props} />;

export const TestimonialColLogo = ({ ...props }) => (
	<Col
		md={6}
		className="align-self-middle text-center"
		spacing={{
			sm: {
				pl: 8,
				pr: 12,
				py: 6,
			},
			md: {
				pl: 12,
				pr: 12,
				py: 10,
			},
		}}
		{...props}
	/>
);
